<template>
  <b-modal
    v-model="onHoldModal"
    hide-header
    centered
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <b-icon-exclamation-circle-fill class="icon-warning" />
        <h4 class="mb-0 text-uppercase modal-title">
          {{ $t('dashboard.addInvoiceBtn') }}
        </h4>
      </div>
      <div class="text-right">
        <b-link class="text-secondary mr-2 h3" @click="$emit('modalClose')">
          <b-icon-x class="text-muted" />
        </b-link>
      </div>
    </div>
    <p class="my-4">{{ $t('buyers.modal.paragraph') }}</p>
    <div class="text-right">
      <b-link
        class="text-secondary mr-2 font-header text-uppercase"
        @click="$emit('modalClose')"
      >
        <small>{{ $t('buyers.modal.cancel') }}</small>
      </b-link>
      <b-button
        size="sm"
        class="py-2 px-2 text-uppercase font-header"
        variant="secondary"
        @click="$emit('modalOk')"
      >
        {{ $t('buyers.modal.okay') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    onHoldModal: {
      type: Boolean,
      default: false
    },
    addBuyerId: {
      type: Number,
      default: null
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/scss/variables';
.icon-warning {
  font-size: 1.6rem;
  color: $pending-color;
  margin-right: 0.5rem;
}
.modal-title {
  letter-spacing: 1px;
  font-family: $montserrat;
  font-weight: bold;
  color: $secondary;
}
.font-header {
  font-family: $montserrat;
}
</style>
